const Logos = ({ imgArr }) => {
  return (
    <div className="max-w-3xl px-5 mx-auto py-10 md:py-20 ">
      <div className="flex flex-row gap-3 md:gap-5 ">
        {imgArr.map((img, idx) => {
          return (
            <div key={idx} className="cursor-pointer">
              <a href={img.link}>
                <img src={img.url} alt={img.alt} />
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Logos;
